import { createSlice, PayloadAction } from "@reduxjs/toolkit";

interface RequestCallbackState {
  isOpen: boolean;
  reason?: string;
  buttonType?: string;

  completed: Record<string, boolean>;
}

interface OpenRequestCallbackPayload {
  reason?: string;
  buttonType: string;
}

const initialState: RequestCallbackState = {
  isOpen: false,
  completed: {},
};

const requestCallbackSlice = createSlice({
  name: "requestCallbackModal",
  initialState,
  reducers: {
    openRequestCallback: (state, action: PayloadAction<OpenRequestCallbackPayload>) => {
      state.isOpen = true;
      state.reason = action.payload.reason;
      state.buttonType = action.payload.buttonType;
    },

    closeRequestCallback: (state) => {
      state.isOpen = false;
      state.reason = undefined;
      state.buttonType = undefined;
    },

    markRequestCallbackSuccess: (state, action: PayloadAction<string>) => {
      state.completed[action.payload] = true;
    },

    resetRequestCallbackSuccess: (state, action: PayloadAction<string>) => {
      delete state.completed[action.payload];
    },
  },
});

export const {
  openRequestCallback,
  closeRequestCallback,
  markRequestCallbackSuccess,
  resetRequestCallbackSuccess,
} = requestCallbackSlice.actions;

export default requestCallbackSlice.reducer;
